/**
 * Tiny localStorage helpers for per-viewer UI conveniences (remembered filters etc.).
 * Every access is wrapped in try/catch: storage may be unavailable (private mode,
 * blocked site data) or full. A failure never breaks the page.
 */

/** Reads and parses a JSON value; returns null when missing, unreadable or invalid JSON. */
export function loadJson(key: string): unknown {
  try {
    const raw = window.localStorage.getItem(key);
    if (raw === null) return null;
    return JSON.parse(raw) as unknown;
  } catch {
    return null;
  }
}

/** Serializes and stores a value; silently ignores storage errors. */
export function saveJson(key: string, value: unknown): void {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // storage unavailable or full: keep working without persistence
  }
}

/** Removes the stored value; silently ignores storage errors. */
export function removeJson(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch {
    // storage unavailable: nothing to remove
  }
}
